/* Shopify forms with one popup action. No browser PII storage or Twilio credentials. */
(() => {
  const all = (scope, selector) => [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
  function init(scope = document) {
    all(scope, '.bz-sms-form').forEach(form => {
      if (form.dataset.smsReady) return;
      form.dataset.smsReady = 'true';
      const phone = form.querySelector('[data-sms-phone]');
      if (!phone) {
        if (form.querySelector('[data-sms-success]')) {
          const popup = form.closest('[data-club-popup]');
          popup?.querySelector('#BoxzyClubForm')?.setAttribute('hidden', '');
          popup?.querySelector('[data-join-submit]')?.setAttribute('hidden', '');
        }
        return;
      }
      const marketing = form.querySelector('[data-sms-marketing]');
      const transactional = form.querySelector('[data-sms-transactional]');
      const terms = form.querySelector('[data-sms-terms]');
      const error = form.querySelector('[data-sms-error]');
      const email = form.querySelector('[data-sms-email]');
      const panel = form.closest('[data-sms-panel]');
      const dialog = form.closest('[data-club-popup]');
      const newsletter = dialog?.querySelector('#BoxzyClubEmail');
      const newsletterForm = newsletter?.form;
      const details = form.querySelector('[data-sms-details]');
      const emailWrap = form.querySelector('[data-sms-email-wrap]');
      const compact = Boolean(panel?.hasAttribute('data-sms-compact'));
      const unified = Boolean(panel?.hasAttribute('data-unified-signup') && newsletterForm);
      const button = unified ? dialog.querySelector('[data-join-submit]') : null;
      const joinError = dialog?.querySelector('[data-join-error]');
      const status = dialog?.querySelector('[data-join-status]');
      if (details && !form.querySelector('[data-sms-result]')) details.open = Boolean(phone.value);
      phone.addEventListener('input', () => { if (details && phone.value.trim()) details.open = true; });
      form.addEventListener('invalid', () => { if (details) details.open = true; }, true);
      let emailEdited = Boolean(email?.value);
      const mirrorEmail = () => {
        if (email && newsletter && (unified || !emailEdited)) email.value = newsletter.value;
        if (compact && emailWrap) emailWrap.hidden = Boolean(newsletter?.value && newsletter.checkValidity() && email.value === newsletter.value);
      };
      email?.addEventListener('input', () => { emailEdited = true; });
      newsletter?.addEventListener('input', mirrorEmail);
      mirrorEmail();
      // Unified layout keeps the optional phone in its contact form, below email.
      // No form nesting, duplicate visible email, or extra signup button.
      if (unified && emailWrap) emailWrap.hidden = true;
      [phone, marketing, transactional, terms].forEach(el => el?.addEventListener('input', () => {
        phone.setCustomValidity(''); error.hidden = true; error.textContent = '';
        if (joinError) { joinError.hidden = true; joinError.textContent = ''; }
      }));
      form.querySelectorAll('[data-sms-policy]').forEach(input => {
        const link = form.querySelector(input.dataset.smsPolicy === 'privacy' ? 'a[href*="privacy"]' : 'a[href*="terms"]');
        if (link) input.value = link.href;
      });
      function prepareSms() {
        mirrorEmail();
        const normalized = phone.value.trim().replace(/[\s().-]/g, '');
        let message = '';
        if (!/^\+[1-9]\d{7,14}$/.test(normalized)) message = 'Include your country code with a +, for example +1 555 000 0000.';
        else if (!marketing.checked && !transactional.checked) message = 'Choose a text message type, or clear your phone number to join by email only.';
        if (message) {
          if (details) details.open = true;
          error.textContent = message; error.hidden = false; phone.focus(); return false;
        }
        if (details) details.open = true;
        if (!form.checkValidity()) { form.reportValidity(); return false; }
        phone.value = normalized;
        form.querySelector('[data-sms-source]').value = location.href;
        form.querySelector('[data-sms-timestamp]').value = new Date().toISOString();
        form.querySelector('[data-sms-body]').value = [
          form.querySelector('[data-sms-brand]').value + ' SMS preferences request — manual review required. No phone verification or SMS send was performed.',
          'Marketing SMS consent: ' + (marketing.checked ? 'Selected' : 'Not selected'),
          'Transactional SMS consent: ' + (transactional.checked ? 'Selected' : 'Not selected'),
          'Terms and Privacy acknowledgement: ' + (terms.checked ? 'Accepted' : 'Not accepted'),
          'Marketing disclosure shown: ' + form.querySelector('[data-sms-marketing-copy]').textContent.trim(),
          'Transactional disclosure shown: ' + form.querySelector('[data-sms-transactional-copy]').textContent.trim(),
          'Consent copy version: boxzy-sms-2026-10-24-v1',
          'Source: ' + location.href,
          'Client-reported time: ' + form.querySelector('[data-sms-timestamp]').value + '. Use the Shopify-delivered email timestamp as receipt evidence.'
        ].join('\n');
        return true;
      }
      form.addEventListener('submit', event => { if (!prepareSms()) event.preventDefault(); });
      if (!unified || !button) return;
      let busy = false;
      let confirmedEmail = '';
      const label = button.innerHTML;
      const setBusy = value => {
        busy = value; button.disabled = value;
        button.innerHTML = value ? 'JOINING…' : label;
        button.setAttribute('aria-busy', String(value));
      };
      const protectedForm = target => new Promise((resolve, reject) => {
        const captcha = window.Shopify?.captcha;
        if (!captcha?.protect) { resolve(); return; }
        const timer = setTimeout(() => reject(new Error('The security check timed out. Please try again.')), 45000);
        try { captcha.protect(target, () => { clearTimeout(timer); resolve(); }); }
        catch (e) { clearTimeout(timer); reject(e); }
      });
      const showError = (message, challenge) => {
        joinError.textContent = message;
        if (challenge) {
          const url = new URL(challenge, location.href);
          if (url.origin === location.origin && url.pathname.includes('/challenge')) {
            const link = document.createElement('a'); link.href = url.href;
            link.target = '_blank'; link.rel = 'noopener';
            link.textContent = ' Complete Shopify’s security check, then try again.';
            joinError.append(link);
          }
        }
        joinError.hidden = false;
        joinError.scrollIntoView({block:'nearest'});
      };
      async function join(event) {
        const smsWanted = Boolean(phone.value.trim() || marketing.checked || transactional.checked);
        // Email-only follows the existing native Shopify form and challenge flow.
        if (!smsWanted) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (busy) return;
        mirrorEmail();
        if (!newsletterForm.checkValidity()) { newsletterForm.reportValidity(); return; }
        if (!prepareSms()) return;
        setBusy(true); joinError.hidden = true;
        const currentChoices = () => JSON.stringify([newsletter.value, phone.value, marketing.checked, transactional.checked, terms.checked]);
        const snapshot = currentChoices();
        const requestedEmail = newsletter.value;
        let navigating = false;
        try {
          if (confirmedEmail !== newsletter.value) {
            status.textContent = 'Joining the email list…';
            await protectedForm(newsletterForm);
            if (snapshot !== currentChoices()) throw new Error('Your details changed. Review your choices and click JOIN THE DROP LIST again.');
            const controller = new AbortController();
            const timer = setTimeout(() => controller.abort(), 30000);
            let response;
            try {
              response = await fetch(newsletterForm.action, {method:'POST', body:new FormData(newsletterForm), credentials:'same-origin', signal:controller.signal});
            } finally { clearTimeout(timer); }
            if (new URL(response.url).pathname.includes('/challenge')) {
              showError('Shopify requires a security check. Your SMS request has not been sent.', response.url); return;
            }
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            if (!response.ok || !doc.querySelector('#BoxzyClubForm [data-club-success]')) {
              const reason = doc.querySelector('#BoxzyClubForm [data-club-error]')?.textContent.trim();
              throw new Error(reason || 'We could not confirm your email signup. Please try again. Your SMS request has not been sent.');
            }
            confirmedEmail = requestedEmail;
          }
          // Re-check consent if the visitor edited anything while Shopify responded.
          if (snapshot !== currentChoices()) {
            throw new Error('Your details changed. Review your choices and click JOIN THE DROP LIST again.');
          }
          status.textContent = 'Email signup confirmed. Sending your selected SMS preferences…';
          await protectedForm(form);
          if (snapshot !== currentChoices()) throw new Error('Your details changed. Review your choices and click JOIN THE DROP LIST again.');
          if (!prepareSms()) return;
          // Native navigation preserves Shopify's contact-form success/errors and challenge flow.
          HTMLFormElement.prototype.submit.call(form);
          navigating = true;
        } catch (e) {
          showError((confirmedEmail ? 'Your email signup is confirmed. ' : '') + (e.name === 'AbortError' ? 'The request timed out. Please try again.' : e.message || 'Please try again.'));
        } finally { if (!navigating) { setBusy(false); status.textContent = ''; } }
      }
      button.addEventListener('click', join);
      newsletterForm.addEventListener('submit', join);
      newsletter.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); button.click(); }
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
